import http from '../helpers/http';

const PromoCode = () => {
  return {
    getCode: async (code: string, schoolId: string) => {
      const result = await http.get(`/promo-codes/${code}/public/${schoolId}`);
      return result.data;
    },
  };
};

export default PromoCode;
